import React from "react";
import {NavLink, useNavigate, useParams} from "react-router-dom";
import * as Utils from "../../inc/Utils";
import {Config} from "../../Config";
import toast, {Toaster} from "react-hot-toast";
import moment from "moment-timezone";
import MemberSidebar from "../../inc/MemberSidebar";
import {confirmAlert} from "react-confirm-alert";
import "react-datepicker/dist/react-datepicker.css";
import MD5 from "crypto-js/md5";

export default function BusinessFormStatus(prop) {
    let navigate = useNavigate();
    let {encode} = useParams();
    let decode = Utils.decodeItem(encode);
    let formId = decode.id;
    let sendStatus = decode.status;

    let member = prop.member;
    let [data, setData] = React.useState(null);
    let [btnDisabled, setBtnDisabled] = React.useState(false);

    let [statusList, setStatusList] = React.useState(null);
    let [objective, setObjective] = React.useState(null);
    let [certificationType, setCertificationType] = React.useState(null);
    let [formType, setFormType] = React.useState(null);
    let [fileNameText, setFileNameText] = React.useState('เปิดไฟล์แนบ');

    React.useEffect(() => {
        document.title = 'แบบฟอร์มคำร้องขอการรับรองคุณภาพ - NCSA';

        (async function() {
            try {
                const resultStatus = await Utils.getFormStatus();
                setStatusList(resultStatus);

                const resObjective = await Utils.getCyberObjectiveType();
                setObjective(resObjective);
                const resCertType = await Utils.getCyberCertificationType();
                setCertificationType(resCertType);
                const resFormType = await Utils.getCyberFormType();
                setFormType(resFormType);

                const result = await getView(formId);
                if(result) {
                    setData(result);

                    if(result.status === Utils.FORM_STATUS_DRAFT
                        || result.status === Utils.FORM_STATUS_EDIT
                        || result.status === Utils.FORM_STATUS_APPROVE
                        || result.status === Utils.FORM_STATUS_EVALUATION_EDIT
                    ) {
                    }
                    else {
                        navigate('/businessForm', {replace: true});
                    }

                    if(result.status === Utils.FORM_STATUS_DRAFT) {
                        if(sendStatus && sendStatus === Utils.FORM_STATUS_CANCELLED) {
                            setBtnStatusText('ยืนยันลบคำขอ');
                        }
                        else {
                            setBtnStatusText('ยืนยันการยื่นคำขอ');
                        }
                    }
                    else if(result.status === Utils.FORM_STATUS_EDIT) {
                        setBtnStatusText('ส่งอัพเดต(แก้ไข)');
                    }
                    else if(result.status === Utils.FORM_STATUS_EVALUATION_EDIT) {
                        setBtnStatusText('ส่งอัพเดต(แก้ไข)หลังการตรวจประเมิน');
                    }
                    else if(result.status === Utils.FORM_STATUS_APPROVE) {
                        setBtnStatusText('แจ้งชำระเงิน');
                    }

                    if(result.status === Utils.FORM_STATUS_APPROVE) {
                        setFileNameText('ดูรายละเอียดการชำระเงิน');
                    }

                    setShowBtnStatus(true);
                    //last status
                    if(result.cyberFormStatus) {
                        let formStatus = result.cyberFormStatus[0];

                        let status_detail = formStatus.detail;
                        let status_enddate = formStatus.endDate;
                        let status_file = formStatus.file;
                        let status_file2 = formStatus.file2;
                        let status_file3 = formStatus.file3;
                        let status_file4 = formStatus.file4;
                        let status_file5 = formStatus.file5;

                        if(status_detail) {
                            result.status_detail = status_detail;
                        }
                        if(status_enddate) {
                            result.status_enddate = status_enddate;
                            if(new Date() > new Date(status_enddate)) {
                                setShowBtnStatus(false);
                            }
                        }

                        if(status_file) {
                            result.status_file = Config.fileUpload + 'cyber_form_status/' + status_file;
                        }
                        if(status_file2) {
                            result.status_file2 = Config.fileUpload + 'cyber_form_status/' + status_file2;
                        }
                        if(status_file3) {
                            result.status_file3 = Config.fileUpload + 'cyber_form_status/' + status_file3;
                        }
                        if(status_file4) {
                            result.status_file4 = Config.fileUpload + 'cyber_form_status/' + status_file4;
                        }
                        if(status_file5) {
                            result.status_file5 = Config.fileUpload + 'cyber_form_status/' + status_file5;
                        }
                    }
                }
            } catch (e) {
                //
            }
        })();

    }, []);

    async function getView(id) {
        const response = await fetch(Config.apiUrl +'/cyberForm/viewByMember', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    //region update status
    let [btnStatusText, setBtnStatusText] = React.useState('');
    let [showBtnStatus, setShowBtnStatus] = React.useState(false);
    let refStatusDetail = React.useRef();

    //ไฟล์แนบ 1 หรือ หลักฐานการชำระเงิน
    let [base64Status, setBase64Status] = React.useState(null);
    let refFileNameStatus = React.useRef();
    let refFileStatus = React.useRef();
    const handleClickStatus = React.useCallback(() => refFileStatus.current?.click(), []);

    //ไฟล์แนบอื่นๆ
    let [base64Status2, setBase64Status2] = React.useState(null);
    let refFileNameStatus2 = React.useRef();
    let refFileStatus2 = React.useRef();
    const handleClickStatus2 = React.useCallback(() => refFileStatus2.current?.click(), []);

    let [base64Status3, setBase64Status3] = React.useState(null);
    let refFileNameStatus3 = React.useRef();
    let refFileStatus3 = React.useRef();
    const handleClickStatus3 = React.useCallback(() => refFileStatus3.current?.click(), []);

    let [base64Status4, setBase64Status4] = React.useState(null);
    let refFileNameStatus4 = React.useRef();
    let refFileStatus4 = React.useRef();
    const handleClickStatus4 = React.useCallback(() => refFileStatus4.current?.click(), []);

    let [base64Status5, setBase64Status5] = React.useState(null);
    let refFileNameStatus5 = React.useRef();
    let refFileStatus5 = React.useRef();
    const handleClickStatus5 = React.useCallback(() => refFileStatus5.current?.click(), []);

    const onSendUpdate = () => {
        let detail = refStatusDetail.current.value;
        let fileNameStatus = refFileNameStatus.current.value;
        let fileNameStatus2 = refFileNameStatus2.current.value;
        let fileNameStatus3 = refFileNameStatus3.current.value;
        let fileNameStatus4 = refFileNameStatus4.current.value;
        let fileNameStatus5 = refFileNameStatus5.current.value;

        let message = '';
        let status = 0;
        if(data?.status === Utils.FORM_STATUS_DRAFT) {
            if(sendStatus && sendStatus === Utils.FORM_STATUS_CANCELLED) {
                message = 'ลบคำขอ';
                status = Utils.FORM_STATUS_CANCELLED;
            }
            else {
                message = 'ยื่นคำขอใหม่';
                status = Utils.FORM_STATUS_NEW;
            }
        }
        else if(data?.status === Utils.FORM_STATUS_EDIT) {
            message = 'ส่งอัพเดต(แก้ไข)';
            status = Utils.FORM_STATUS_UPDATE;
        }
        else if(data?.status === Utils.FORM_STATUS_APPROVE) {
            message = 'แจ้งชำระเงิน';
            status = Utils.FORM_STATUS_PAYMENT;
        }
        else if(data?.status === Utils.FORM_STATUS_EVALUATION_EDIT) {
            message = 'ส่งอัพเดต(แก้ไข)หลังการตรวจประเมิน';
            status = Utils.FORM_STATUS_EVALUATION_UPDATE;
        }

        if(data?.status === Utils.FORM_STATUS_APPROVE && !fileNameStatus) {
            toast.error(prop.lang === 'en' ? 'Please browser file':'กรุณาแนบหลักฐานการชำระเวิน');
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ยืนยัน ' + message + ' ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async () => {
                            setBtnDisabled(true);

                            let fullname = member.firstname + ' ' + member.lastname;
                            let status_name = statusList ? statusList.filter(e => e.id === status)[0]?.title : '';
                            let datetime = moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss');

                            let objectiveTitle = objective ? objective.filter(e => e.id === data?.objective)[0]?.title : '-';
                            let formTypeTitle = formType ? formType.filter(e => e.id === data?.formType)[0]?.title : '-';
                            let certificationTypeTitle = certificationType ? certificationType.filter(e => e.id === data?.certificationType)[0]?.title : '-';

                            let fileStatus = null;
                            if(fileNameStatus) {
                                fileStatus = MD5(moment().format("YMMDDHHmmss") + 'slip').toString() + '.' + fileNameStatus.split('.').pop();
                            }

                            let fileStatus2 = null;
                            if(fileNameStatus2) {
                                fileStatus2 = MD5(moment().format("YMMDDHHmmss") + '222').toString() + '.' + fileNameStatus2.split('.').pop();
                            }

                            let fileStatus3 = null;
                            if(fileNameStatus3) {
                                fileStatus3 = MD5(moment().format("YMMDDHHmmss") + '333').toString() + '.' + fileNameStatus3.split('.').pop();
                            }

                            let fileStatus4 = null;
                            if(fileNameStatus4) {
                                fileStatus4 = MD5(moment().format("YMMDDHHmmss") + '444').toString() + '.' + fileNameStatus4.split('.').pop();
                            }

                            let fileStatus5 = null;
                            if(fileNameStatus5) {
                                fileStatus5 = MD5(moment().format("YMMDDHHmmss") + '555').toString() + '.' + fileNameStatus5.split('.').pop();
                            }

                            let param = {
                                id: data?.id,
                                detail: detail,
                                status: status,

                                fileStatus: fileStatus,
                                base64Status: base64Status,

                                fileStatus2: fileStatus2,
                                base64Status2: base64Status2,

                                fileStatus3: fileStatus3,
                                base64Status3: base64Status3,

                                fileStatus4: fileStatus4,
                                base64Status4: base64Status4,

                                fileStatus5: fileStatus5,
                                base64Status5: base64Status5,

                                createdBy: -1,
                                createdAt: datetime
                            };
                            const result = await sendUpdate(param);
                            if(result) {
                                setBtnDisabled(false);
                                toast.success(prop.lang === 'en' ? 'Send Offer successfully.':'แจ้ง' + message + ' เรียบร้อย');
                                setTimeout(function () {
                                    toast(prop.lang === 'en' ? 'Sending email, please wait..':'กำลังส่งอีเมล กรุณารอสักครู่..');
                                }, 1000);
                                if(result.status === 'success') {
                                    setBtnDisabled(true);

                                    let adminList = [];
                                    if(data.cyberFormAdmin && data.cyberFormAdmin.length > 0) {
                                        for(let rs of data.cyberFormAdmin) {
                                            adminList.push(rs.adminUser.email);
                                        }
                                    }
                                    else {
                                        adminList = result.email_admin;
                                    }

                                    const sendMember = await sendEmail({
                                        email: data?.member.email,
                                        code: data?.code,
                                        objective: objectiveTitle,
                                        form_type: formTypeTitle,
                                        certification_type: certificationTypeTitle,
                                        company_name: data?.member.businessName,
                                        status_detail: detail,
                                        send_date: datetime,
                                        status_name: status_name,
                                        sender_name: fullname
                                    });
                                    const sendAdmin = await sendEmailAdmin({
                                        emails: adminList,
                                        code: data?.code,
                                        objective: objectiveTitle,
                                        form_type: formTypeTitle,
                                        certification_type: certificationTypeTitle,
                                        company_name: data?.member.businessName,
                                        status_detail: detail,
                                        send_date: datetime,
                                        status_name: status_name,
                                        sender_name: fullname
                                    });

                                    if(sendMember.status === 1 && sendAdmin.status === 1) {
                                        toast.success(prop.lang === 'en' ? 'Send Offer successfully.': 'ส่งอีเมลแจ้ง ' + message + ' เรียบร้อย');
                                        setTimeout(function () {
                                            setBtnDisabled(false);
                                            navigate('/businessForm', {replace: true});
                                        }, 1500);
                                    }
                                    else {
                                        toast.error(prop.lang === 'en' ? 'Sorry, Unable to send email at this time':'ขออภัย ไม่สามารถส่งอีเมลได้ในขณะนี้');
                                    }
                                }
                                else {
                                    toast.error(prop.lang === 'en' ? 'Sorry, there is a problem. Please contact the administrator':'ขออภัยมีเหตุขัดข้อง กรุณาติดต่อผู้ดูแลระบบ');
                                }
                            }
                            else {
                                toast.error(prop.lang === 'en' ? 'Sorry, Service is not available at this time. Please contact the administrator.':'ขออภัย ทำรายการได้ในขณะนี้ กรุณาติดต่อผู้่ดูแลระบบ');
                            }
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    async function sendUpdate(param) {
        const response = await fetch(Config.apiUrl +'/cyberForm/sendUpdate', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function sendEmailAdmin(param) {
        const response = await fetch(Config.phpUrl +'/email_cyberform_admin.php', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function sendEmail(param) {
        const response = await fetch(Config.phpUrl +'/email_cyberform_member.php', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }
    //endregion

    return (
        <>
            <div className="section">
                <div className="container has-sidebar">
                    <div className="sidebar">
                        <MemberSidebar active="businessForm" lang={prop.lang} />
                    </div>
                    <div className="content">
                        <div className="card-infos has-shadow-black" data-aos="fade-in">
                            <div className="d-flex justify-content-between gap-3">
                                <h3 className="title-line-left mt-0 mb-4">{prop.lang === 'en' ? 'Business Quality Form':'แบบฟอร์มคำร้องขอการรับรองคุณภาพ'}</h3>
                                <NavLink to={'/businessForm'} className="btn btn-xs btn-gray">&larr; กลับไป</NavLink>
                            </div>

                            <div className="row g-3">
                                <div className="col-12">
                                    <div className="form-group">
                                        <h6>เลขที่คำขอ</h6>
                                        <div>{data?.code ?? '-'}</div>
                                    </div>
                                </div>
                                <div className={"col-12" + (showBtnStatus ? '':' d-none')}>
                                    <div className="col-12">
                                        <h6>สถานะปัจจุบัน</h6>
                                        <div>

                                            {
                                                data?.status ? <span className={"badge " + (Utils.formStatusColor(data?.status))}>{statusList.filter(e => e.id === data?.status)[0].title}</span> : ''
                                            }

                                            {
                                                data?.status_detail ? <p className="mb-0 mt-1">{data?.status_detail}</p> : ''
                                            }

                                            {
                                                data?.status_enddate ? <p className="mb-0 mt-1 text-danger">ครบกำหนดแจ้งชำระเงิน ในวันที่ {Utils.dateTimeText(data?.status_enddate)}</p> : ''
                                            }

                                            {
                                                data?.status_file ? <p className="mb-0 mt-1"><NavLink to={data?.status_file} target="_blank" className="btn btn-xs btn-gray w-200">&darr; {fileNameText}</NavLink></p> : ''
                                            }

                                            {
                                                data?.status_file2 ? <p className="mb-0 mt-1"><NavLink to={data?.status_file2} target="_blank" className="btn btn-xs btn-gray w-200">&darr; ไฟล์อื่นๆ (2)</NavLink></p> : ''
                                            }

                                            {
                                                data?.status_file3 ? <p className="mb-0 mt-1"><NavLink to={data?.status_file3} target="_blank" className="btn btn-xs btn-gray w-200">&darr; ไฟล์อื่นๆ (3)</NavLink></p> : ''
                                            }

                                            {
                                                data?.status_file4 ? <p className="mb-0 mt-1"><NavLink to={data?.status_file4} target="_blank" className="btn btn-xs btn-gray w-200">&darr; ไฟล์อื่นๆ (4)</NavLink></p> : ''
                                            }

                                            {
                                                data?.status_file5 ? <p className="mb-0 mt-1"><NavLink to={data?.status_file5} target="_blank" className="btn btn-xs btn-gray w-200">&darr; ไฟล์อื่นๆ (5)</NavLink></p> : ''
                                            }
                                        </div>

                                    </div>
                                </div>

                                <div className={"col-12" + (showBtnStatus && (data?.status === Utils.FORM_STATUS_APPROVE || data?.status === Utils.FORM_STATUS_EVALUATION_EDIT) ? '':' d-none')}>
                                    <div className="form-group">
                                        <h6>{data?.status === Utils.FORM_STATUS_APPROVE ? 'แนบหลักฐานการชำระเงิน' : 'แนบไฟล์เอกสาร'}</h6>
                                        <div className="input-group">
                                            <input type="text" className="form-control" ref={refFileNameStatus} readOnly={true} />
                                            <button type="button" className="input-group-text" htmlFor="inputGroupFile" onClick={handleClickStatus}>เลือกไฟล์</button>
                                            <button type="button" className={"input-group-text" + (base64Status ? ' d-block':' d-none')} onClick={e => {
                                                refFileNameStatus.current.value = '';
                                                setBase64Status('');
                                            }}>ลบ</button>
                                        </div>
                                        <p className="small text-danger my-1"> * ชนิดไฟล์ .jpg, .png, .jpeg, .pdf ขนาดไม่เกิน {Utils.maxFileSize5Mb}MB</p>
                                        <input type="file" className="form-control d-none" ref={refFileStatus} onChange={(e) => {
                                            Utils.onSelectFile(e).then(
                                                data => {
                                                    if(data) {
                                                        refFileNameStatus.current.value = e.target.files[0].name;
                                                        setBase64Status(data);
                                                    }
                                                }
                                            );
                                        }} accept={Utils.allowFileExtension} />
                                    </div>
                                </div>

                                <div className={"col-12" + (showBtnStatus && data?.status === Utils.FORM_STATUS_EVALUATION_EDIT ? '':' d-none')}>
                                    <div className="form-group">
                                        <h6>แนบไฟล์เอกสาร (2)</h6>
                                        <div className="input-group">
                                            <input type="text" className="form-control" ref={refFileNameStatus2} readOnly={true} />
                                            <button type="button" className="input-group-text" htmlFor="inputGroupFile2" onClick={handleClickStatus2}>เลือกไฟล์</button>
                                            <button type="button" className={"input-group-text" + (base64Status2 ? ' d-block':' d-none')} onClick={e => {
                                                refFileNameStatus2.current.value = '';
                                                setBase64Status2('');
                                            }}>ลบ</button>
                                        </div>
                                        <p className="small text-danger my-1"> * ชนิดไฟล์ .jpg, .png, .jpeg, .pdf ขนาดไม่เกิน {Utils.maxFileSize5Mb}MB</p>
                                        <input type="file" className="form-control d-none" ref={refFileStatus2} onChange={(e) => {
                                            Utils.onSelectFile(e).then(
                                                data => {
                                                    if(data) {
                                                        refFileNameStatus2.current.value = e.target.files[0].name;
                                                        setBase64Status2(data);
                                                    }
                                                }
                                            );
                                        }} accept={Utils.allowFileExtension} />
                                    </div>
                                </div>

                                <div className={"col-12" + (showBtnStatus && data?.status === Utils.FORM_STATUS_EVALUATION_EDIT ? '':' d-none')}>
                                    <div className="form-group">
                                        <h6>แนบไฟล์เอกสาร (3)</h6>
                                        <div className="input-group">
                                            <input type="text" className="form-control" ref={refFileNameStatus3} readOnly={true} />
                                            <button type="button" className="input-group-text" htmlFor="inputGroupFile3" onClick={handleClickStatus3}>เลือกไฟล์</button>
                                            <button type="button" className={"input-group-text" + (base64Status3 ? ' d-block':' d-none')} onClick={e => {
                                                refFileNameStatus3.current.value = '';
                                                setBase64Status3('');
                                            }}>ลบ</button>
                                        </div>
                                        <p className="small text-danger my-1"> * ชนิดไฟล์ .jpg, .png, .jpeg, .pdf ขนาดไม่เกิน {Utils.maxFileSize5Mb}MB</p>
                                        <input type="file" className="form-control d-none" ref={refFileStatus3} onChange={(e) => {
                                            Utils.onSelectFile(e).then(
                                                data => {
                                                    if(data) {
                                                        refFileNameStatus3.current.value = e.target.files[0].name;
                                                        setBase64Status3(data);
                                                    }
                                                }
                                            );
                                        }} accept={Utils.allowFileExtension} />
                                    </div>
                                </div>

                                <div className={"col-12" + (showBtnStatus && data?.status === Utils.FORM_STATUS_EVALUATION_EDIT ? '':' d-none')}>
                                    <div className="form-group">
                                        <h6>แนบไฟล์เอกสาร (4)</h6>
                                        <div className="input-group">
                                            <input type="text" className="form-control" ref={refFileNameStatus4} readOnly={true} />
                                            <button type="button" className="input-group-text" htmlFor="inputGroupFile4" onClick={handleClickStatus4}>เลือกไฟล์</button>
                                            <button type="button" className={"input-group-text" + (base64Status4 ? ' d-block':' d-none')} onClick={e => {
                                                refFileNameStatus4.current.value = '';
                                                setBase64Status4('');
                                            }}>ลบ</button>
                                        </div>
                                        <p className="small text-danger my-1"> * ชนิดไฟล์ .jpg, .png, .jpeg, .pdf ขนาดไม่เกิน {Utils.maxFileSize5Mb}MB</p>
                                        <input type="file" className="form-control d-none" ref={refFileStatus4} onChange={(e) => {
                                            Utils.onSelectFile(e).then(
                                                data => {
                                                    if(data) {
                                                        refFileNameStatus4.current.value = e.target.files[0].name;
                                                        setBase64Status4(data);
                                                    }
                                                }
                                            );
                                        }} accept={Utils.allowFileExtension} />
                                    </div>
                                </div>

                                <div className={"col-12" + (showBtnStatus && data?.status === Utils.FORM_STATUS_EVALUATION_EDIT ? '':' d-none')}>
                                    <div className="form-group">
                                        <h6>แนบไฟล์เอกสาร (5)</h6>
                                        <div className="input-group">
                                            <input type="text" className="form-control" ref={refFileNameStatus5} readOnly={true} />
                                            <button type="button" className="input-group-text" htmlFor="inputGroupFile5" onClick={handleClickStatus5}>เลือกไฟล์</button>
                                            <button type="button" className={"input-group-text" + (base64Status5 ? ' d-block':' d-none')} onClick={e => {
                                                refFileNameStatus5.current.value = '';
                                                setBase64Status5('');
                                            }}>ลบ</button>
                                        </div>
                                        <p className="small text-danger my-1"> * ชนิดไฟล์ .jpg, .png, .jpeg, .pdf ขนาดไม่เกิน {Utils.maxFileSize5Mb}MB</p>
                                        <input type="file" className="form-control d-none" ref={refFileStatus5} onChange={(e) => {
                                            Utils.onSelectFile(e).then(
                                                data => {
                                                    if(data) {
                                                        refFileNameStatus5.current.value = e.target.files[0].name;
                                                        setBase64Status5(data);
                                                    }
                                                }
                                            );
                                        }} accept={Utils.allowFileExtension} />
                                    </div>
                                </div>

                                <div className={"col-12" + (showBtnStatus ? '':' d-none')}>
                                    <div className="form-group">
                                        <h6>หมายเหตุ</h6>
                                        <input type="text" className="form-control" id="statusDetail" ref={refStatusDetail} maxLength={250} />
                                    </div>
                                </div>

                                <div className="col-12">
                                    <button className={"btn btn-xs" + (sendStatus && sendStatus === Utils.FORM_STATUS_CANCELLED ? ' btn-light':' btn-green')} type="button" onClick={onSendUpdate} disabled={btnDisabled}>
                                        <span className={btnDisabled ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {btnStatusText}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Toaster position="top-right" />
        </>
    );
} 